"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DebugProduct = void 0;
var _mui = require("@ori-ui/mui");
var _contexts = require("../../../../../contexts");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render debug info for product.
 */
const DebugProduct = ({
  amount,
  maxQuantityToBuy,
  remainingItemQuantity,
  remainingQuantity,
  remainingQuantityPerAmount,
  remainingQuantityPerPoints
}) => {
  const {
    showDebugInfo
  } = (0, _contexts.useCheckoutOffers)();
  if (!showDebugInfo) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["remainingItemQuantity: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: remainingItemQuantity
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["remainingQuantity: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: remainingQuantity
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["remainingQuantityPerAmount: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: remainingQuantityPerAmount
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["remainingQuantityPerPoints: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: remainingQuantityPerPoints
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("u", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("strong", {
          children: ["maxQuantityToBuy: ", maxQuantityToBuy]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      children: ["amount: ", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: amount
      })]
    })]
  });
};
exports.DebugProduct = DebugProduct;